import React, {Component} from "react";

export default class ItemUser extends Component {
    render() {
        let {resourcename, resourceid, senderid, sendername} = this.props;

        let hrmid = resourceid;
        let hrmname = resourcename;
        if (senderid != "" && sendername != "") {
            hrmid = senderid;
            hrmname = resourcename;
        }

        return (
            <div className="common sysfav-list-item-info-user">
                <a href={`javaScript:openhrm(${hrmid});`} onClick={event => window.pointerXY(event)}
                   title={hrmname}>{hrmname}
                </a>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/favourite/components/favourite/ItemUser.js